import ApiService from "../api";

export default class MetaFilialService extends ApiService {

    constructor() {
        super("/api/meta-filial");
    }


    criarEstruturaAno(data) {
        return this.post("", data);
    }

    atualizar(id, data) {
        return this.put(`/${id}`, data);
    }

    listarPorFilialEAno(filialId, ano) {
        return this.get(`/filial/${filialId}/ano/${ano}`);
    }

    deletar(id) {
        return this.delete(`/${id}`);
    }
}